import { User } from "@/types/User.interface";
import styles from "./OtherUsers.module.css";
import { CancelButton } from "@/components/button/SaveEditCancel/CancelButton";
import { observer } from "mobx-react-lite";
import { permissionsStore } from "@/stores/PermissionsStore";
import { SaveButton } from "@/components/button/SaveEditCancel/SaveButton";
import { DefaultSwitch } from "@/components/switch/DefaultSwitch/DefaultSwitch";
import Delete from "@/assets/icons/common/delete.svg?react";
import EditIcon from "@/assets/icons/common/edit.svg?react";
import QuestionIcon from "@/assets/icons/common/question.svg?react";
import { TematicalColorButton } from "@/components/button/TematicalColorButton/TematicalColorButton";
import { useEffect, useState } from "react";
import { userStore } from "@/stores/UserStore";
import { userAnotherPanelState } from "@/stores/ComponentsState/UserAnotherPanelState";

export const OtherUser = observer(({ user }: { user: User }) => {
  const [loading, setLoading] = useState(false);
  const permissions = permissionsStore.getPermissionsByRoleId(userStore.role!);
  const { users: usersAction } = permissions!.typePermissions;

  useEffect(() => {
    setLoading(false);
  }, [user.active]);

  return (
    <div className={styles.user}>
      <div className={styles.top}>
        <div className={styles.topLeft}>
          <div className={styles.section} style={{ padding: "2px 8px" }}>
            <b>Логин: </b>
            <span>{user.login}</span>
          </div>
          <div className={styles.section}>
            <b>ФИО: </b>
            <span>{user.fio}</span>
            <SaveButton
              disabled={!usersAction.edit}
              onClick={() => userAnotherPanelState.setCurrentUser(user, "fio")}
              icon={<EditIcon />}
            ></SaveButton>
          </div>
          <div className={styles.section}>
            <b>Роль: </b>
            <span>{permissionsStore.getPermissionsByRoleId(user.role!)?.roleName}</span>
            <SaveButton
              disabled={!usersAction.edit}
              onClick={() => userAnotherPanelState.setCurrentUser(user, "role")}
              icon={<EditIcon />}
            ></SaveButton>
          </div>
          <div className={styles.section}>
            <b>Пароль: </b>
            <SaveButton
              disabled={!usersAction.edit}
              onClick={() => userAnotherPanelState.setCurrentUser(user, "password")}
              icon={<EditIcon />}
            ></SaveButton>
          </div>
          <div className={styles.section}>
            <b>Права: </b>
            <TematicalColorButton
              onClick={() => userAnotherPanelState.setCurrentUser(user, "info")}
              icon={<QuestionIcon />}
            ></TematicalColorButton>
          </div>
        </div>
        <div className={styles.topRight}>
          <div className={styles.section} style={{ borderRadius: "24px" }}>
            <b>Активный</b>
            <DefaultSwitch
              loading={loading}
              disabled={!usersAction.edit}
              switchTriggerValue={user.active}
              returnValueFn={() => {
                userStore.toggleActiveUser(user.id!);
                setLoading(true);
              }}
            />
          </div>
          <CancelButton
            disabled={!usersAction.delete}
            onClick={() => userAnotherPanelState.setCurrentUser(user, "delete")}
          >
            <Delete className={styles.deleteSvg} />
          </CancelButton>
        </div>
      </div>
    </div>
  );
});
